var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ring-card-action-box grid gap-no" }, [
      _c("div", { staticClass: "span-1" }, [
        _c("img", {
          attrs: { src: _vm.icons.accountVerification, width: "32" },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "span-8" },
        [
          _c("AccountVerificationPanel", {
            attrs: {
              "expires-at": _vm.pii.authorization.expires_at,
              "is-approved-status": _vm.pii.authorization.status === "active",
              "is-verification-required":
                (!_vm.pii.authorization.status &&
                  _vm.backendAuthorizationStatus !== "pending") ||
                (_vm.backendAuthorizationStatus === "pending" &&
                  !_vm.getStartedAt),
              "is-pending":
                (_vm.pii.authorization.status ||
                  _vm.backendAuthorizationStatus === "pending") &&
                _vm.getStartedAt !== undefined,
              "status-message": _vm.statusMessage,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "span-3 button-container" }, [
        _c(
          "div",
          { staticClass: "customer-field" },
          [
            _c("AccountVerificationButtons", {
              attrs: {
                "is-verify-account-button-visible":
                  !_vm.pii.authorization.status ||
                  _vm.pii.authorization.status === "pending",
                "is-verify-account-disabled": _vm.disableVerifyAccount,
                "is-verify-override-button-visible":
                  _vm.hasOverrideAuthPermission,
                "on-close-action": _vm.fetchPIIAuthorization,
                "is-revoke-auth-button-visible":
                  _vm.pii.authorization.status === "active",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }